import { render } from "./rePasword.vue?vue&type=template&id=791e5e71&scoped=true"
import script from "./rePasword.vue?vue&type=script&lang=js"
export * from "./rePasword.vue?vue&type=script&lang=js"

import "./rePasword.vue?vue&type=style&index=0&id=791e5e71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791e5e71"]])

export default __exports__